import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.distribution`;
export const SCOPE_REQUEST = `${SCOPE}.request`;
export const SCOPE_CORE = `${SCOPE}.core`;

export const INIT = `${SCOPE}/INIT`;
export const SET_BUCKET_TIME = `${SCOPE}/SET_BUCKET_TIME`;
export const SET_HIGHLIGHT_BUCKET = `${SCOPE}/SET_HIGHLIGHT_BUCKET`;
export const REST_BUCKET_TIME = `${SCOPE}/REST_BUCKET_TIME`;
export const INJECT_SHARED_STATE = `${SCOPE}/INJECT_SHARED_STATE`;
export const SET_LEGENDS = `${SCOPE}/SET_LEGENDS`;
export const RESET_LEGENDS = `${SCOPE}/RESET_LEGENDS`;
